<template>
	<div class="track">
		<h4 v-if="props.title != null">
			{{ props.title }}
		</h4>
			<audio controls v-if="props.src != null" :src=props.src></audio>
		<div class="desc">
			<slot></slot>
		</div>

	</div>
</template>

<script setup>
const props = defineProps(
	[
		'title',
		'src',


	]
)

</script>